<template>
    <div class="video-grid">
      <ModelPaidVideoCard
        v-for="(video, index) in videos"
        :key="index"
        :video="video"
        :locked="!isImageUnlocked(video)"
        @play="openPlayer(index)"
        @subscribe="handleVideoSubscribe"
        @likeVideo="handleVideoLike"
      />
      
      <!-- VIDEO PLAYER MODAL -->
      <transition name="fade">
        <div v-if="showPlayer" class="video-modal" @click.self="closePlayer">
          <!-- CLOSE -->
          <button class="close-btn" @click="closePlayer">×</button>

          <!-- LEFT -->
          <button class="nav-btn left" @click="prevVideo">
            ‹
          </button>

          <!-- PLAYER -->
          <div class="player-container">
            <div class="player-header" v-if="currentVideo">
              <div class="player-copy">
                <p class="player-eyebrow">Now playing</p>
                <h3 class="player-title">{{ currentVideo.title }}</h3>
                <!-- <p class="player-subtitle">
                  Watch the preview, then unlock the full video if you want more.
                </p> -->
              </div>

              <div class="player-stats">
                <div class="player-stat">
                  <span class="stat-label">Views</span>
                  <strong class="stat-value">
                    <i class="fa fa-eye"></i>
                    {{ formatCount(getVideoViews(currentVideo)) }}
                  </strong>
                </div>

                <div class="player-stat">
                  <span class="stat-label">Duration</span>
                  <strong class="stat-value">{{ currentVideo.duration || 'N/A' }}</strong>
                </div>
              </div>
            </div>

            <div class="player-frame" v-if="currentVideo">
              <video
                ref="player"
                :src="currentVideo.file_path"
                controls
                autoplay
                playsinline
              ></video>
            </div>
          </div>

          <!-- RIGHT -->
          <button class="nav-btn right" @click="nextVideo">
            ›
          </button>
        </div>
      </transition>

      <!-- Subscription Modal -->
      <transition name="fade">
        <div v-if="showSubscriptionModal" class="subs-backdrop">
          <div class="subs-modal">
            <!-- Header -->
            <div class="subs-header">
              <div>
                <h4 class="subs-title">
                  <i class="bi bi-credit-card"></i>
                  Unlock Content
                </h4>
                <p class="subs-subtitle">
                  Choose a subscription plan or make a one-time purchase
                </p>
              </div>

              <button class="subs-close" @click="showSubscriptionModal = false">×</button>
            </div>

            <!-- Body -->
            <div class="subs-body">
              <!-- One-time Purchase -->
              <div v-if="dayruns_token" class="one-time-box">
                <p class="one-time-text">One-time access</p>

                <button
                  class="btn btn-success one-time-btn"
                  @click="purchaseAssets(media_price, dayruns_token, asset_id)"
                >
                  <i class="fa fa-shopping-cart"></i>
                  Buy for {{ formatPrice(dayruns_token) }}{{ token_label }}
                </button>
              </div>

              <!-- Divider -->
              <div v-if="dayruns_token && services.length" class="divider">
                <span>OR</span>
              </div>

              <!-- Subscription Plans -->
              <div v-if="services.length" class="plans-section">
                <h5 class="plans-title">Subscription Plans</h5>

                <div class="plans-grid">
                  <div
                    class="plan-card"
                    v-for="(service, index) in services"
                    :key="index"
                  >
                    <div class="plan-header">
                      <h6>{{ service.category }}</h6>
                    </div>

                    <div class="plan-body">
                      <p class="plan-price">
                        {{ service.dayruns_token }}{{ token_label }}
                      </p>
                      <p class="plan-duration">
                        {{ service.duration ? service.duration + ' days' : 'Unlimited' }}
                      </p>
                    </div>

                    <button
                      class="btn btn-success w-100"
                      :disabled="service.enabled !== 'true'"
                      @click="bookService(service)"
                    >
                      Subscribe
                    </button>
                  </div>
                </div>
              </div>

              <!-- Empty State -->
              <div v-if="!services.length && !media_price" class="empty-state">
                <i class="bi bi-emoji-frown"></i>
                <p>No subscription plans available</p>
              </div>
            </div>

            <!-- Footer -->
            <div class="subs-footer">
              <button class="btn btn-outline-secondary" @click="showSubscriptionModal = false;">
                Close
              </button>
            </div>
          </div>
        </div>
      </transition>


    </div>
  </template>
<script>
  import ModelPaidVideoCard from "./ModelPaidVideoCard.vue";

  export default {
  components: { ModelPaidVideoCard },
  props: {
    videos: Array
  },
  data() {
    return {
      showPlayer: false,
      //currentVideo: {},
      currentIndex: 0,
      showSubscriptionModal: false,
      media_price: null,
      dayruns_token: '',
      asset_id: null,
      services: [],
      logoutSplash: false,
      userid: '',
      escortid: '',
      selectedPlan: '',
      selectedId: '',
      payment_service: [],
      payment_ref: '',
      user_email: '',
      apikey: '',
      active_purchases: [],
      active_subscriptions: false,
      token_label: process.env.VUE_APP_TOKEN_LABEL,
    };
  },
  computed: {
    currentVideo() {
      return this.videos[this.currentIndex];
    }
  },
  watch: {
    videos: {
    immediate: true,
    handler(newVideos) {
      if (newVideos && newVideos.length) {
        const escort_user_id = newVideos[0].escort_user_id;
        const escortId = newVideos[0].userid;

        this.fetchClientActiveSubscription(
          escort_user_id,
          this.userid
        );

        this.fetchActivePurchases(escortId);
      }
    }
  }
 },
  async beforeMount(){ 
    await this.getConfigData()
    const user = localStorage.getItem("userid");

    if (user) {
      this.userid = user;
    }
  
    if (this.videos.length) {
      const escort_user_id = this.videos[0].escort_user_id;
      const escortId = this.videos[0].userid;
      this.fetchClientActiveSubscription(escort_user_id, this.userid )
      await this.fetchActiveVideoPurchases(escortId);
    }
  },

  async mounted() {
    const user = localStorage.getItem("userid");

    const email = localStorage.getItem("email");
    if (user) {
      this.user_email = email;
    }
    
    window.addEventListener("keydown", this.handleKey);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKey);
  },
  methods: {
    
    async handleVideoLike(video) {
    try {
        if (!this.userid) {
        
          setTimeout(() => {
          this.$router.push("/login")
          }, 500); // splash visible for 5 seconds

          return;
        }

        const response = await this.$http.post('/like-video', {
          video_id: video.id,
          liked_by: this.userid,
          escort_id: video.userid,
        });

        if (response.data.success) {

           // refresh like count instantly
           video.likes = response.data.likes;

          // Set splash message
          this.logoutMessage = response.data.message || "Liked Successful!";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds

        } else {
          
          // Set splash message
          this.logoutMessage = response.data.message || "Unable to like video";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds
        }
    } catch (err) {
      console.error(err);
    }
    },

    async fetchServices(escortid) {
      try {
        const response = await this.$http.get(`/list-subscription-plans/${escortid}`);
        if (response.data.success) {
          this.services = response.data.data;
        } else {
          this.logoutMessage = response.data.message || "Failed to load services";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds
        }
      } catch (err) {
        console.error(err);
        this.logoutMessage = "An error occurred while fetching services";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds
      }
    },
    async purchaseAssets(price, dayruns_token, asset_id) {
    try {
      // Add confirmation alert before proceeding
      const confirmed = confirm("Are you sure you want to buy this asset?");
      if (!confirmed) return; // Stop execution if user cancels

      const response = await this.$http.post('/create-media-purchase', {
        client_id: this.userid,  // client id
        model_id: this.escortid,  // model id
        asset_id: asset_id,
        amount: price,
        dayruns_token: dayruns_token
      });

      if (response.data.success) {
        // Set splash message
        this.active_purchases.push(this.asset_id);
        this.showSubscriptionModal = false;

        alert(response.data.message || "Video unlocked successfully!");
        return;
      }
    } catch (err) {
      alert(err.response ? err.response.data.message : err.message);
    }
    },
    async bookService(service){
      try {
        if (!this.userid) {
          // Set splash message
          this.logoutMessage = "Please login to subscribe for this plan!";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          this.$router.push('/login');
          }, 2500); // splash visible for 2.5 seconds
          return;
        }

        const confirmed = confirm("Proceed to subscribe?");
        if (!confirmed) return; // Stop execution if user cancels
        
        this.showSubscriptionModal = false
        this.selectedPlan = service.category
        this.selectedId = service.id
        this.payment_service = service

        const payment_reference = "PAY-" + Date.now();
        
        this.pay(this.userid, this.payment_service, payment_reference)
        
        
    } catch (err) {
      console.error(err);
      
    }
    },
    async fetchClientActiveSubscription(escortid, user_id) {
      try {
        const response = await this.$http.get(`/get-active-subscriptions/${escortid}/${user_id}`);
        if (response.data.success) {
          const services = response.data.data;
          // Check if services is not null/undefined and has at least one record
          if (services && Array.isArray(services) && services.length > 0) {
            this.active_subscriptions = true;
          } else {
            this.active_subscriptions = false;
          }

        } 
      } catch (err) {
        console.error(err);
      }
    },
    async fetchActiveVideoPurchases(escortid) {
      if (!this.userid) return;

      try {
        const response = await this.$http.get(
          `/get-active-video-purchase/${escortid}/${this.userid}`
        );

        if (response.data.success) {
          this.active_purchases = response.data.data.map(i => i.asset_id);
        }
      } catch (err) {
        console.error(err);
        this.active_purchases = [];
      }
    },
    isImageUnlocked(video) {
    // Free image
    if (!video.dayruns_token || video.dayruns_token === 0) return true;

    // Subscription unlocks all
    if (this.active_subscriptions) return true;

    // One-time purchase
    return this.active_purchases.includes(video.id);

    },

    async pay(user_id, payment_service, payment_reference) {
        try{
          const response = await this.$http.post('/book-escort-service', {
            user_id: user_id,
            service: payment_service,
            payment_reference: payment_reference
          });

        if (response.data.success) {
        // Set splash message
        this.logoutMessage = response.data.message || "Payment Successful!";
        this.logoutSplash = true;
        // Wait before redirecting
        setTimeout(() => {
            this.logoutSplash = false
            this.showSubscriptionModal = false;
            alert(`Plan "${this.selectedPlan}" activated!`);    
            window.location.reload();
        }, 2500); // splash visible for 2.5 seconds

        } else {

          // Set splash message
          this.logoutMessage = response.data.message || "Unable to Process.";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds

        }
            
        }catch (err) {
          console.log(err);
      }

    },
    async getConfigData(){
        const response = await fetch('/config.json');
        const configData = await response.json();
        this.apikey = configData.apikey;
    },
    formatPrice(value) {
      return new Intl.NumberFormat('en-NG', {
      minimumFractionDigits: 0
    }).format(value);
    },
    openPlayer(index) {
      if (!this.isImageUnlocked(this.videos)) {
        this.handleVideoSubscribe(this.videos);
        return;
      }

      this.currentIndex = index;
      this.showPlayer = true;
      document.body.style.overflow = "hidden";
    },
    handleVideoSubscribe(video) {
      this.escortid = video.userid
      this.fetchServices(video.userid);
      this.fetchActiveVideoPurchases(video.userid);
      this.openSubscription(video.price, video.dayruns_token, video.id);
    },
    openSubscription(price, dayruns_token, asset_id) {
      if (!this.userid) {
            // Set splash message
            this.logoutMessage = "Please login to subscribe!";
            this.logoutSplash = true;
            // Wait before redirecting
            setTimeout(() => {
            this.logoutSplash = false;
            this.$router.push('/login');
            }, 2500); // splash visible for 2.5 seconds
            return;
      }
      this.media_price = price
      this.dayruns_token = dayruns_token
      this.asset_id = asset_id
      this.showSubscriptionModal = true;
    },
    closePlayer() {
      this.showPlayer = false;
      document.body.style.overflow = "";
      this.$refs.player?.pause();
    },

    nextVideo() {
      let nextIndex = this.currentIndex;

      do {
        nextIndex = (nextIndex + 1) % this.videos.length;
      } while (
        this.videos[nextIndex].locked && 
        nextIndex !== this.currentIndex
      );

      // stop if next is locked and no unlocked found
      if (!this.videos[nextIndex].locked) {
        this.currentIndex = nextIndex;
      }

      this.restartVideo();
    },

    prevVideo() {
      let prevIndex = this.currentIndex;

      do {
        prevIndex =
          (prevIndex - 1 + this.videos.length) %
          this.videos.length;
      } while (
        this.videos[prevIndex].locked &&
        prevIndex !== this.currentIndex
      );

      if (!this.videos[prevIndex].locked) {
        this.currentIndex = prevIndex;
      }

      this.restartVideo();
    },

    restartVideo() {
      this.$nextTick(() => {
        const player = this.$refs.player;
        if (player) {
          player.pause();
          player.load();
          player.play();
        }
      });
    },
    getVideoViews(video) {
      if (!video) return 0;
      return video.views ?? video.likes ?? 0;
    },
    formatCount(value) {
      const number = Number(value) || 0;
      return new Intl.NumberFormat("en-US").format(number);
    },
    handleKey(e) {
      if (!this.showPlayer) return;
      if (e.key === "ArrowRight") this.nextVideo();
      if (e.key === "ArrowLeft") this.prevVideo();
      if (e.key === "Escape") this.closePlayer();
    }
  }
};

  </script>
  
<style lang="scss" scoped>
    .modal-maskp {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .4s ease;
    
    & > div {
        width: 80%;
        height: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        //padding: 2em;
        border: 0.5px solid #D33E74;
        background: #19181B;
        border-radius: 20px;
        box-sizing: border-box;
    }
.player-title{
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 24px;
    line-height: 42px;
    text-align: center;
    color: #FFFFFF;
}
.amount {
    display: flex;
    flex-direction: row;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 19px;
    color: #FFFFFF;
    justify-content: space-between;
    .fees {
        
    }
    .price {
    
        font-family: 'Nunito';
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 27px;
        color: #D33E74;
    }
}
.payment-option{
    display: flex; 
    flex-direction: row; 
}
.payment-types {
    width: 388px;
    height: 254px;
    background: #272528;
    border-radius: 8px;
    cursor: pointer;
    margin-bottom:20px;
    font-family: 'Nunito';
    font-style: normal;
    .payhow{
        font-family: 'Nunito';
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 10px;
        letter-spacing: -0.02em;
        color: #FFFFFF;
        text-align: center;
        margin-top: 10px;
    }
    .payment{
        margin:15px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0px 14px;
        width: 314px;
        height: 46px;
        background: #19181B;
        border-radius: 4px;
        font-family: 'Nunito';
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        line-height: 22px;
        letter-spacing: -0.02em;
        color: #FFFFFF;
    }

    h3{
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        line-height: 42px;
        text-align: center;
        color: #0A070F;
    }
    
    
}
.player-payinfo{
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    text-align: center;
    color: #FFFFFF;
    display: block;
    margin-left: auto;
    margin-right: auto;
}
.player-button{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px;
    height: auto;
    width: 40px;
    background: #333;
    border-radius: 5px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    color: #FFFFFF;
    margin-top: 10px;
    margin-bottom: 30px;
    //display: block;
    margin-left: auto;
    margin-right: auto;
}   
}
.video-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* 🖥 Desktop: 6 columns */
  gap: 20px;
}

/* 📲 Tablets (iPad portrait & landscape) */
  @media (max-width: 1024px) {
  .video-grid {
      grid-template-columns: repeat(4, 1fr);
  }
  }

/* 📱 Mobile */
@media (max-width: 768px) {
  .video-grid {
    grid-template-columns: repeat(2, 1fr); /* 2 columns */
    gap: 4px;
    padding-right: calc(var(--bs-gutter-x) * .0);
    padding-left: calc(var(--bs-gutter-x) * .0);
  }
}

.video-modal {
position: fixed;
inset: 0;
background: rgba(0, 0, 0, 0.95);
display: flex;
align-items: center;
justify-content: center;
z-index: 9999;
}

.player-container {
  width: min(92vw, 1080px);
  background: linear-gradient(180deg, #12111a 0%, #09090f 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 32px 90px rgba(0,0,0,0.72);
  padding: 20px;
}

.player-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.player-copy {
  flex: 1;
  min-width: 0;
}

.player-eyebrow {
  margin: 0 0 6px;
  color: #f7a7c0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.player-title {
  margin: 0;
  color: #fff;
  font-family: "Raleway", sans-serif;
  font-size: 28px;
  line-height: 1.2;
  font-weight: 800;
  word-break: break-word;
}

.player-subtitle {
  margin: 8px 0 0;
  color: rgba(255, 255, 255, 0.72);
  font-size: 14px;
  line-height: 1.5;
}

.player-stats {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.player-stat {
  min-width: 132px;
  padding: 12px 14px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  text-align: left;
}

.stat-label {
  display: block;
  color: rgba(255, 255, 255, 0.7);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.stat-value {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #fff;
  font-size: 15px;
  font-weight: 800;
}

.player-frame {
  border-radius: 20px;
  overflow: hidden;
  background: #000;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.player-container video {
  width: 100%;
  aspect-ratio: 16 / 9;
  height: auto;
  background: #000;
}

.video-details {
  padding: 12px 16px;
background: #0f0f1a;
color: #fff;
}

.video-details h3 {
font-size: 16px;
margin: 0;
}

.video-details span {
font-size: 12px;
opacity: 0.7;
}

.close-btn {
position: absolute;
top: 20px;
right: 30px;
font-size: 34px;
background: none;
border: none;
color: #fff;
cursor: pointer;
}

/* Fade animation */
.fade-enter-active,
.fade-leave-active {
transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
opacity: 0;
}

/* 📱 Mobile */
@media (max-width: 768px) {
.player-container {
  width: 94vw;
  padding: 14px;
  border-radius: 18px;
}

.player-header {
  flex-direction: column;
  align-items: stretch;
}

.player-title {
  font-size: 22px;
}

.player-subtitle {
  font-size: 13px;
}

.player-stat {
  min-width: 0;
  flex: 1 1 140px;
}
}

.nav-btn {
position: absolute;
top: 50%;
transform: translateY(-50%);
font-size: 60px;
background: none;
border: none;
color: #fff;
cursor: pointer;
padding: 12px;
opacity: 0.8;
z-index: 10;
}

.nav-btn:hover {
opacity: 1;
}

.nav-btn.left {
left: 20px;
}

.nav-btn.right {
right: 20px;
}

/* Hide arrows on small screens if needed */
@media (max-width: 768px) {
.nav-btn {
  font-size: 44px;
}

.nav-btn.left {
  left: 4px;
}

.nav-btn.right {
  right: 4px;
}
}

.subs-backdrop {
position: fixed;
inset: 0;
background: rgba(0, 0, 0, 0.75);
z-index: 9999;
display: flex;
align-items: center;
justify-content: center;
width: 100%;
height: 100%;
}

.subs-modal {
width: 90%;
max-width: 600px;
background: #fff;
border-radius: 14px;
max-height: 80vh;   /*limit height */
overflow: hidden;   /* prevent outside scroll */
box-shadow: 0 25px 80px rgba(0, 0, 0, 0.35);
}

/* Mobile optimization */
@media (max-width: 768px) {
  .subs-modal {
    max-height: 80vh;
    border-radius: 10px;
    overflow: scroll;   /* prevent outside scroll */
  }

  .plans-grid {
    display: grid;
    grid-template-columns: 1fr 1fr; /* 2 grids on mobile */
    gap: 10px;
  }
}

/* Extra small phones */
@media (max-width: 480px) {
  .plans-grid {
    grid-template-columns: 1fr; /* 1 per row if too tight */
  }
}

.subs-header {
display: flex;
justify-content: space-between;
align-items: center;
padding: 20px 24px;
background: linear-gradient(135deg, #D33E74, #D33E74);
color: #fff;
}

.subs-title {
margin: 0;
font-weight: 600;
}

.subs-subtitle {
font-size: 13px;
opacity: 0.85;
}

.subs-close {
font-size: 28px;
background: none;
border: none;
color: #fff;
cursor: pointer;
}

.subs-body {
  max-height: 65vh;   /* limits height inside modal */
  overflow-y: auto;   /* enables vertical scroll */
  padding-right: 6px; /* space for scrollbar */
  padding: 30px 24px;
}

/* Optional smooth scrollbar */
.subs-body::-webkit-scrollbar {
  width: 6px;
}

.subs-body::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}


.one-time-box {
background: #f0fdf4;
border: 1px solid #bbf7d0;
padding: 20px;
border-radius: 12px;
text-align: center;
}

.one-time-text {
font-weight: 600;
margin-bottom: 10px;
}
.btn-success{
  background: #D33E74;
  border: solid 0px;
}
.btn-success:hover{
  background: #D33E74;
}

.one-time-btn {
font-size: 14px;
padding: 10px 18px;
}

.divider {
text-align: center;
margin: 30px 0;
position: relative;
}

.divider span {
background: #fff;
padding: 0 14px;
font-weight: 600;
color: #6b7280;
}

.divider::before {
content: "";
  position: absolute;
  inset: 50% 0 auto 0;
  height: 1px;
  background: #e5e7eb;
  z-index: -1;
}

.plans-title {
  font-weight: 600;
  margin-bottom: 16px;
  text-align: center;
}

.plans-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Desktop */
  gap: 15px;
  margin-top: 10px;
}

/* Tablet */
@media (max-width: 992px) {
  .plans-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile → Force 2 columns */
@media (max-width: 576px) {
  .plans-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
}

.plan-card {
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  transition: all 0.25s ease;
}

.plan-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.plan-header h6 {
  font-weight: 600;
  margin-bottom: 10px;
  text-transform: capitalize;
}

.plan-price {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 4px;
}

.plan-duration {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 18px;
}

.empty-state {
  text-align: center;
  color: #9ca3af;
  padding: 40px 0;
}

.empty-state i {
  font-size: 40px;
  margin-bottom: 10px;
}

.subs-footer {
  padding: 16px 24px;
  background: #f9fafb;
  text-align: right;
}
</style>
